import Cookies from 'js-cookie';
import { axiosManager } from '../../axios-manager';
import MatchCRUDProps from './index.d';

class MatchCRUD {
  private readonly token;

  constructor() {
    this.token = Cookies.get('token') || '';
  }
  create({
    advisor_id,
    personal_client_id,
    vacancy_id,
  }: MatchCRUDProps.createParams) {
    return axiosManager<MatchCRUDProps.createReturn>({
      method: 'post',
      url: `/vacancy-match/create`,
      auth: this.token,
      payload: {
        advisor_id,
        personal_client_id,
        vacancy_id,
        authorized: false,
      },
    });
  }

  read({ page = 1, per_page = 9, vacancy_id, personal_client_id, updated_at_end, updated_at_start }: MatchCRUDProps.readParams) {
    let url = `/vacancy-match/list?page=${page}&per_page=${per_page}`;
    if (vacancy_id) url = url + `&vacancy_id=${vacancy_id}`;
    else if(personal_client_id)  url = url + `&personal_client_id=${personal_client_id}`;
    
    if (updated_at_start) url = url + `&updated_at_start=${updated_at_start}`;
    if (updated_at_end) url = url + `&updated_at_end=${updated_at_end}`;
    
    return axiosManager<MatchCRUDProps.readReturn>({
      method: 'get',
      url,
      auth: this.token,
      payload: null,
    });
  }

  update({
    advisor_id,
    authorized,
    personal_client_id,
    vacancy_id,
    match_id,
    attachment_id
  }: MatchCRUDProps.updateParams) {
    return axiosManager<MatchCRUDProps.updateReturn>({
      method: 'put',
      url: `/vacancy-match/update/${match_id}`,
      auth: this.token,
      payload: {
        advisor_id,
        authorized,
        personal_client_id,
        vacancy_id,
        attachment_id
      },
    });
  }

  delete({ id }: MatchCRUDProps.deleteParams) {
    return axiosManager<MatchCRUDProps.deleteReturn>({
      method: 'delete',
      url: `/vacancy-match/delete/${id}`,
      auth: this.token,
      payload: null,
    });
  }
}

export { MatchCRUD };
